import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["sticky", "stickyTimer"];
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useInView } from '@blaze-react/utils/lib/customHooks';
import recreateOnNavigation from '../../HOC/recreateOnNavigation';
import Layout from './Layout';
const LayoutWithStickyTimer = _ref => {
  let {
      sticky,
      stickyTimer
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const [isIntersecting, outerRef] = useInView({});
  const [isSticky, setIsSticky] = useState(sticky);
  useEffect(() => {
    if (isIntersecting && sticky && !!stickyTimer) {
      setIsSticky(true);
      const timer = setTimeout(() => {
        setIsSticky(false);
      }, stickyTimer);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [isIntersecting, stickyTimer, sticky]);
  return /*#__PURE__*/React.createElement(Layout, _extends({}, otherProps, {
    sticky: isSticky,
    ref: sticky ? outerRef : null
  }));
};
LayoutWithStickyTimer.propTypes = {
  sticky: PropTypes.bool,
  stickyTimer: PropTypes.number
};
LayoutWithStickyTimer.defaultProps = {
  sticky: false,
  stickyTimer: 0
};
export default recreateOnNavigation(LayoutWithStickyTimer);
//# sourceMappingURL=LayoutWithStickyTimer.js.map